module.exports = __webpack_public_path__ + "static/ENdeskSlide1-b1bb0eddd9ea1d2d623e31c6392af8c2.png";